import { render } from "./ViewerPadButton.vue?vue&type=template&id=b78598d4"
import script from "./ViewerPadButton.vue?vue&type=script&lang=js"
export * from "./ViewerPadButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DBN26\\Documents\\workspaces\\packaged-viewer-hbm\\packaged-viewer-hbm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__